import AprilFoolsUpload from '../classes/AprilFoolsUpload';
import Spotlight from 'spotlight.js/src/js/spotlight';

function _getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
}

function _setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = "expires="+ d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

export default function(){
    /* Profile Upload */
    jQuery('.af-profile-upload').each(function(){
        new AprilFoolsUpload(jQuery(this));
    });

    jQuery(document).on('click', '.af-upload-success-close', function(){
        window.open(window.location.href + '#promocodes', '_self');
        window.location.reload();
    });

    /* Profile Delete */
    jQuery('.af-profile-remove').on('click', function(){
        window.laughRemoveId = jQuery(this).data('id');

        jQuery('.af-entry-remove').addClass('active');
    });

    jQuery('.af-entry-remove-close').on('click', function(){
        if(window.laughRemoveId == undefined) return;

        jQuery.post('/removeAprilLaugh', {
            id: window.laughRemoveId
        }, function(data){
            window.location.reload();
        });
    });

    /* Like Confirmation Popup */
    jQuery('.af-liked-popup-close').on('click', function(){
        jQuery('.af-liked-popup').removeClass('active');
    });

    /* Vote */ 
    jQuery('.af-voting-action').on('click', function(){
        let $item = jQuery(this).parents('.af-voting-item');
        if( $item.hasClass('is-voted') ) return;

        let id      = $item.data('id');
        let $vcount = $item.find('.vote-count');

        jQuery.post('/likeAprilLaugh', {
            id: id
        }, function(data){
            $vcount.text( parseInt($vcount.text(), 10) + 1 );
            $item.addClass('is-voted');

            let liked   = _getCookie('liked_april_laughs');
            liked       = liked.split(',').map(v => parseInt(v, 10));

            liked.push(parseInt(id, 10));
            liked       = liked.filter((v, i, a) => a.indexOf(v) === i);
            liked       = liked.filter((v) => typeof v !== 'string' && !(v instanceof String));

            _setCookie('liked_april_laughs', liked.join(','), 7);
            jQuery('.af-liked-popup').addClass('active');
        });
    });

    /* Lightbox */
    jQuery('.af-voting-item-open').on('click', function(){
        let $item   = jQuery(this).parents('.af-voting-item');

        let isVideo = $item.hasClass('is-video');
        let url     = $item.data('url');

        Spotlight.show([{src: url}], {
            media: isVideo ? "video" : "image",
            autoplay: true
        });
    });

    /* Share */
    jQuery('.af-voting-item-actions-share').on('click', function(){
        let url = jQuery(this).data('share-url');
        
        jQuery('.af-share-popup-url-input').val( url );
        jQuery('.af-share-popup').addClass('active');
    });

    jQuery('.af-share-popup-url-input').on('click', function(){
        this.select();
        this.setSelectionRange(0, 99999);

        navigator.clipboard.writeText( this.value );
    });

    jQuery('.af-share-popup-close').on('click', function(){
        jQuery('.af-share-popup').removeClass('active');
    });

    /* Share (open lightbox and scroll to) */
    jQuery('.af-voting-items').each(function(){
        let hash = window.location.hash;
        if( hash.includes('view') ){
            hash = hash.replace('#', '');
            hash = hash.split('=');
            if( hash.length == 2 && hash[0] == 'view' ){
                let id = hash[1];
                let $item = jQuery('.af-voting-item[data-id="' + id + '"]');

                if($item.length > 0){
                    jQuery([document.documentElement, document.body]).animate({
                        scrollTop: $item.offset().top - 100
                    }, 1000);

                    let isVideo = $item.hasClass('is-video');
                    let url     = $item.data('url');

                    setTimeout(function(){
                        Spotlight.show([{src: url}], {
                            media: isVideo ? "video" : "image",
                            autoplay: true
                        });
                    }, 1200);
                }
            }
        }
    });
}